import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css'
//yayi
import { getUser, getAdmin, isLogged, isAdminLogged, checkTokenExpiration, logout, checkAdminTokenExpiration } from './services/helpers'
import EventsPage from './pages/attendee/EventsPage'
import EventDetailPage from './pages/attendee/EventDetailPage'
import OffersPage from './pages/attendee/OffersPage'
import OfferDetailPage from './pages/attendee/OfferDetailPage'
import Login from './pages/Login'
import SignupPage from './pages/SignupPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import OrdersPage from './pages/attendee/OrdersPage'
import TicketsPage from './pages/attendee/TicketsPage'
import SupportPage from './pages/attendee/SupportPage'
import AttendeeDashboardPage from './pages/attendee/AttendeeDashboardPage'
import AttendeeProfilePage from './pages/attendee/AttendeeProfilePage'
import AttendeeDisputesPage from './pages/attendee/AttendeeDisputesPage'
import CenterEventsPage from './pages/center/CenterEventsPage'
import CenterEventsListPage from './pages/center/CenterEventsListPage'
import CenterEventDetailPage from './pages/center/CenterEventDetailPage'
import EventFormPage from './pages/center/EventFormPage'
import CenterOffersPage from './pages/center/CenterOffersPage'
import CenterOfferDetailPage from './pages/center/CenterOfferDetailPage'
import OfferFormPage from './pages/center/OfferFormPage'
import CenterTicketsPage from './pages/center/CenterTicketsPage'
import CenterOrdersPage from './pages/center/CenterOrdersPage'
import CenterDisputesPage from './pages/center/CenterDisputesPage'
import CenterWalletPage from './pages/center/CenterWalletPage'
import CenterProfilePage from './pages/center/CenterProfilePage'
import CenterMediaPage from './pages/center/CenterMediaPage'
import CenterSupportPage from './pages/center/CenterSupportPage'
import CenterTicketVerificationPage from './pages/center/CenterTicketVerificationPage'
import CenterSignupPage from './pages/center/CenterSignupPage'
import CentersListPage from './pages/public/CentersListPage'
import PublicCenterProfilePage from './pages/public/CenterProfilePage'
import CenterDashboardPage from './pages/center/CenterDashboardPage'
import AdminLogin from './admin/AdminLogin'
import AdminLayout from './admin/AdminLayout'
import AdminHomePage from './pages/admin/AdminHomePage'
import AdminCenters from './admin/pages/AdminCenters'
import AdminCenterDetails from './admin/pages/AdminCenterDetails'
import AdminAttendees from './admin/pages/AdminAttendees'
import AdminAttendeeDetails from './admin/pages/AdminAttendeeDetails'
import AdminEvents from './admin/pages/AdminEvents'
import AdminEventDetails from './admin/pages/AdminEventDetails'
import AdminTickets from './admin/pages/AdminTickets'
import AdminTicketDetails from './admin/pages/AdminTicketDetails'
import AdminOrders from './admin/pages/AdminOrders'
import AdminOrderDetails from './admin/pages/AdminOrderDetails'
import AdminPayouts from './admin/pages/AdminPayouts'
import AdminPayoutDetails from './admin/pages/AdminPayoutDetails'
import AdminDisputes from './admin/pages/AdminDisputes'
import AdminDisputeDetails from './admin/pages/AdminDisputeDetails'
import AdminPayments from './admin/pages/AdminPayments'
import AdminPaymentDetails from './admin/pages/AdminPaymentDetails'
import AdminOffers from './admin/pages/AdminOffers'
import AdminOfferDetails from './admin/pages/AdminOfferDetails'
import AdminComingSoon from './admin/pages/AdminComingSoon'
import AdminSystemUsers from './admin/pages/AdminSystemUsers'
import AdminNewUser from './admin/pages/AdminNewUser'
import AdminEditUser from './admin/pages/AdminEditUser'
import AdminReports from './admin/pages/AdminReports'
import AdminAudit from './admin/pages/AdminAudit'
import AdminProfile from './admin/pages/Profile'
import LandingPage from './pages/landing/LandingPage'
import VerifyEmail from './pages/VerifyEmail'
import PaymentSuccess from './pages/PaymentSuccess'
import PaymentFailed from './pages/PaymentFailed'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfUsePage from './pages/TermsOfUsePage'
import RefundPolicyPage from './pages/RefundPolicyPage'
import PricingPage from './pages/PricingPage'
import ContactPage from './pages/ContactPage'
import HelpCenterPage from './pages/HelpCenterPage'
import FaqPage from './pages/FaqPage'
import CookieBanner from './components/CookieBanner'

const RequireAuth = ({ roles = [], children }) => {
  const logged = isLogged()
  if (!logged) {
    // Redirect based on route - admin routes go to admin login
    const isAdminRoute = window.location.pathname.startsWith('/admin')
    return <Navigate to={isAdminRoute ? "/admin/login" : "/login"} replace />
  }
  
  // Check for user or admin
  const user = getUser()
  const admin = getAdmin()
  const currentUser = user || admin

  // If no user/admin object, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />
  }

  // If roles are specified, check if user has required role
  if (roles.length > 0) {
    if (!currentUser.role || !roles.includes(currentUser.role)) {
      // If user is logged in but wrong role, redirect to appropriate dashboard
      if (currentUser.role === 'CENTER') {
        return <Navigate to="/center" replace />
      } else if (currentUser.role === 'ATTENDEE') {
        return <Navigate to="/events" replace />
      } else if (currentUser.role === 'ADMIN' || currentUser.role === 'SUPER_ADMIN') {
        return <Navigate to="/admin" replace />
      }
      // If role doesn't match and no specific redirect, go to home
      return <Navigate to="/" replace />
    }
  }

  return children
}

const RedirectIfAuthed = ({ children }) => {
  const logged = isLogged()
  const adminLogged = isAdminLogged()
  
  if (logged || adminLogged) {
    const user = getUser()
    const admin = getAdmin()
    const currentUser = admin || user
    
    if (currentUser?.role === 'CENTER') {
      return <Navigate to="/center" replace />
    }
    if (currentUser?.role === 'ATTENDEE') {
      return <Navigate to="/account" replace />
    }
    if (currentUser?.role === 'ADMIN' || currentUser?.role === 'SUPER_ADMIN' || currentUser?.role === 'SUPER_MODERATOR') {
      return <Navigate to="/admin" replace />
    }
    return <Navigate to="/" replace />
  }
  return children
}

function App() {
  // Check token expiration periodically (every 5 minutes)
  useEffect(() => {
    const checkExpiration = () => {
      checkTokenExpiration()
    }
    checkExpiration()
    const interval = setInterval(checkExpiration, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  // Check admin token if on admin routes (but not on login page)
  useEffect(() => {
    const currentPath = window.location.pathname
    const isAdminLoginRoute = currentPath === '/admin/login'
    
    // Don't check token on login page
    if (currentPath.startsWith('/admin') && !isAdminLoginRoute) {
      const checkAdminAuth = async () => {
        await checkAdminTokenExpiration()
      }
      checkAdminAuth()
      
      // Check every 5 minutes for admin routes
      const interval = setInterval(checkAdminAuth, 5 * 60 * 1000)
      return () => clearInterval(interval)
    }
  }, [])

  window.onclose = (e) => {
    logout()
  }

  return (
    <>
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/events/:eventId" element={<EventDetailPage />} />
      <Route path="/offers" element={<OffersPage />} />
      <Route path="/offers/:offerId" element={<OfferDetailPage />} />
      <Route path="/centers" element={<CentersListPage />} />
      <Route path="/centers/:centerId/events" element={<PublicCenterProfilePage />} />
      <Route path="/centers/:centerId/offers" element={<PublicCenterProfilePage />} />
      <Route path="/centers/:centerId" element={<PublicCenterProfilePage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failed" element={<PaymentFailed />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfUsePage />} />
      <Route path="/refund" element={<RefundPolicyPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/help" element={<HelpCenterPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route
        path="/login"
        element={
          <RedirectIfAuthed>
            <Login />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <RedirectIfAuthed>
            <ForgotPasswordPage />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/reset-password/:userId/:token"
        element={
          <RedirectIfAuthed>
            <ResetPasswordPage />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/verify-email/:userId/:token"
        element={
          <RedirectIfAuthed>
            <VerifyEmail />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/signup"
        element={
          <RedirectIfAuthed>
            <SignupPage />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/center/signup"
        element={
          <RedirectIfAuthed>
            <CenterSignupPage />
          </RedirectIfAuthed>
        }
      />

      {/* Attendee */}
      <Route
        path="/account"
        element={
          <RequireAuth roles={['ATTENDEE']}>
            <AttendeeDashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account/orders"
        element={
          <RequireAuth roles={['ATTENDEE']}>
            <OrdersPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account/tickets"
        element={
          <RequireAuth roles={['ATTENDEE']}>
            <TicketsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account/disputes"
        element={
          <RequireAuth roles={['ATTENDEE']}>
            <AttendeeDisputesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account/profile"
        element={
          <RequireAuth roles={['ATTENDEE']}>
            <AttendeeProfilePage />
          </RequireAuth>
        }
      />
      <Route
        path="/account/support"
        element={
          <RequireAuth roles={['ATTENDEE']}>
            <SupportPage />
          </RequireAuth>
        }
      />

      {/* Center */}
      <Route path="/center/login" element={<Login defaultRole="CENTER" />} />
      <Route
        path="/center"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterDashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/events/create"
        element={
          <RequireAuth roles={['CENTER']}>
            <EventFormPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/events"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterEventsListPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/events/:eventId"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterEventDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/offers"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterOffersPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/offers/create"
        element={
          <RequireAuth roles={['CENTER']}>
            <OfferFormPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/offers/:offerId/edit"
        element={
          <RequireAuth roles={['CENTER']}>
            <OfferFormPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/offers/:offerId"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterOfferDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/tickets"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterTicketsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/orders"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterOrdersPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/disputes"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterDisputesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/wallet"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterWalletPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/media"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterMediaPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/verify"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterTicketVerificationPage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/profile"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterProfilePage />
          </RequireAuth>
        }
      />
      <Route
        path="/center/support"
        element={
          <RequireAuth roles={['CENTER']}>
            <CenterSupportPage />
          </RequireAuth>
        }
      />

      {/* Admin */}
      <Route 
        path="/admin/login" 
        element={
          <RedirectIfAuthed>
            <AdminLogin />
          </RedirectIfAuthed>
        } 
      />
      <Route
        path="/admin"
        element={
          <RequireAuth roles={['ADMIN', 'SUPER_ADMIN']}>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<AdminHomePage />} />
        <Route path="centers" element={<AdminCenters />} />
        <Route path="centers/:userId" element={<AdminCenterDetails />} />
        <Route path="attendees" element={<AdminAttendees />} />
        <Route path="attendees/:userId" element={<AdminAttendeeDetails />} />

        {/* Core operations */}
        <Route path="events" element={<AdminEvents />} />
        <Route path="events/:eventId" element={<AdminEventDetails />} />
        <Route path="offers" element={<AdminOffers />} />
        <Route path="offers/:offerId" element={<AdminOfferDetails />} />
        <Route path="tickets" element={<AdminTickets />} />
        <Route path="tickets/:ticketId" element={<AdminTicketDetails />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="orders/:orderId" element={<AdminOrderDetails />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="payments/:paymentId" element={<AdminPaymentDetails />} />
        <Route path="payouts" element={<AdminPayouts />} />
        <Route path="payouts/:payoutId" element={<AdminPayoutDetails />} />
        <Route path="disputes" element={<AdminDisputes />} />
        <Route path="disputes/:disputeId" element={<AdminDisputeDetails />} />
        <Route path="system-users" element={<AdminSystemUsers />} />
        <Route path="system-users/new" element={<AdminNewUser />} />
        <Route path="system-users/:userId/edit" element={<AdminEditUser />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="profile" element={<AdminProfile />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <CookieBanner />
    </>
  )
}

export default App
